// extracted by mini-css-extract-plugin
export default {"frame":"GeofenceMap_frame__a5Z9n","canvas":"GeofenceMap_canvas__GWPux","empty":"GeofenceMap_empty__pdBfx"};